// extracted by mini-css-extract-plugin
module.exports = {"TableHolder":"Table_TableHolder__BDDJQ","LastTd":"Table_LastTd__3XGEQ","EditeHolder":"Table_EditeHolder__3V9KY","RemoveHolder":"Table_RemoveHolder__3KJKY"};